import { logWrapper } from '../../utils';

export default {
  chatbotService: [
    'runtimeConstant',
    '$http',
    '$q',
    'webApiSettings',
    function (
      runtimeConstant,
      $http,
      $q,
      webApiSettings,
    ) {
      'use strict';

      function handleError(err, status) {
        //falhou
        if (status === 404 || status === -1) {
          var error = {
            status_code: status,
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            status_code: status,
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function getUri(idCompany, productName) {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}chatbot/uri?IdCompany=${idCompany}&ProductName=${productName}`)
          .then(
            function (res) {
              deferred.resolve(res.data);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          var chatbotServiceFactory = {};

          chatbotServiceFactory.getUri = logWrapper(
            getUri,
            runtimeConstant.isDebugServicesInternals
          );

          return chatbotServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
